var map = {
	"./bg_welcome.png": "ecab",
	"./experience1.png": "981f",
	"./experience2.png": "2605",
	"./experience3.png": "6353",
	"./freelance1.png": "1697",
	"./freelance2.png": "5e88",
	"./freelance3.png": "7fd2",
	"./photograph1.png": "3706",
	"./photograph2.png": "3ba4",
	"./photograph3.png": "8315"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7eba";